module.exports = __webpack_public_path__ + "img/qr-slide-mob-2.d524e3ed.png";